import type { FC } from 'react';
import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { PapiUser } from '@wix/da-papi-types';
import { SessionContext } from '@wix/da-react-context/pkg/publicSession';
import { BiLoggerContextProvider } from '@wix/da-bi/pkg/BiLogger.context';
import DevpageSidebarPlacement from '@wix/da-shared-react/pkg/DealerAd/Placement/DevpageSidebar';
import Heading from '@wix/da-a11y/pkg/components/headings/Heading';
import { Section, Main, Aside } from '@wix/da-a11y/pkg/components/headings/tagWrappers';
import { getHomeCounts, getHomeCurrencies } from '../../../selectors/studio/home';
import CounterBlock from '../CounterBlock';
import BenefitBlock from '../BenefitBlock';

import s from './StudioHomePageContent.scss';

const StudioHomePageContent: FC<{}> = () => {
  const { t } = useTranslation();
  const { user } = useContext(SessionContext);
  const counts = useSelector(getHomeCounts);
  const currencies = useSelector(getHomeCurrencies);

  return (
    <div className={s['root']}>
      <Main>
        <div className={s['heading']}>
          <Heading className={s['welcome']}>
            {t('studio.home.heading', {
              username: (user as PapiUser)?.username,
            })}
          </Heading>
          <p>{t('studio.home.subheading')}</p>
        </div>
        <Section>
          <BiLoggerContextProvider value={{ sectionname: 'studio_activity' }}>
            <Heading className={s['section-heading']}>{t('studio.home.activity')}</Heading>
            <div className={s['activity-content']}>
              {counts &&
                Object.entries(counts).map(([cType, cValue]) => (
                  <CounterBlock key={`counter-${cType}`} type={cType} value={cValue} />
                ))}
            </div>
          </BiLoggerContextProvider>
        </Section>
        <Section>
          <BiLoggerContextProvider value={{ sectionname: 'studio_benefits' }}>
            <Heading className={s['section-heading']}>{t('studio.home.benefits')}</Heading>
            <div className={s['benefits-content']}>
              {currencies &&
                Object.entries(currencies).map(([cType, cValue]) => (
                  <BenefitBlock key={`benefit-${cType}`} type={cType} value={cValue} />
                ))}
            </div>
          </BiLoggerContextProvider>
        </Section>
      </Main>
      <Aside>
        <DevpageSidebarPlacement />
      </Aside>
    </div>
  );
};
StudioHomePageContent.displayName = 'StudioHomePageContent';

export default StudioHomePageContent;
